import Paginate from 'vuejs-paginate'
import LayoutMain from './../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../ProgressHUD/index.vue'
import ProjectItem from './FundProjectItem/index.vue'
import GreenFundDetails from './../GreenFundDetails/index.vue'
import Api from '../../../services/api'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Paginate,
    ProjectItem,
    GreenFundDetails,
  },
  mounted() {},
  data() {
    return {
      projects: null,
      highlightPrj: {},
      pageNumber: null,
      itemCount: 9,
      rowCount: 3,
      pageCount: null,
      validationMessage: '',
      theme: '',
      country: '',
      continent: '',
      search: {
        text: '',
        type: '',
        theme: '',
        continent: '',
        country: '',
        numberPage: 1,
        countPages: 1,
        limit: 9,
        my: false,
      },
      daysAll: 45,
      themes: {
        0: 'Solar',
        1: 'Wind',
        2: 'Bio mass',
        3: 'Hydro',
        4: 'Other renewables',
      },
      continents: [],
      countries: [],
    }
  },
  watch: {
    $route() {
      this.search.text = this.$route.query.text || ''
      this.search.theme = this.$route.query.theme || ''
      this.search.continent = this.$route.query.continent || ''
      this.search.country = this.$route.query.country || ''
      this.search.numberPage = +this.$route.query.page || 1
      this.search.my = this.$route.query.my || false

      this.refreshDisplayProjects()
    },
  },
  methods: {
    changeAllFilter() {
      this.theme = '';
      this.continent = '';
      this.country = '';
      this.$router.push({
        query: Object.assign({}),
      })
    },
    changeTypeFilter(type) {
      var theme = ""
      // if(type == 'theme') theme = this.theme =
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          theme: this.theme,
          continent: this.continent,
          country: this.country,
        }),
      })
    },
    changePage(numberPage) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: numberPage,
        }),
      })
    },
    searchClick() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          text: this.search.text,
        }),
      })
    },
    getDays(updated) {
      var date = new Date(),
          now = date.getTime()
      return (this.daysAll - Math.round((now - updated)/(1000*60*60*24)))
    },
    async refreshDisplayProjects() {
      try {
        // this.$refs.progress.show()

        var response = await Api.getFundProjects(this.search)

        console.log("response--------------")
        console.log(response)

        for (var i=0; i<response.data.results.length; i++){
          response.data.results[i].numberDate = this.getDays(response.data.results[i].updated)
        }
        console.log("response--------------2")


        var resHigh = await Api.getHighlightProjects()
        resHigh.data.results[0].numberDate = this.getDays(resHigh.data.results[0].updated)

        this.projects = response.data.results
        console.log("response--------------3")

        this.highlightPrj = resHigh.data.results[0]
        this.search.countPages = response.data.pagination.countPages
        console.log(response)

        function sort(a) {
            return a.sort().filter(function(item, pos, ary) {
                return !pos || item != ary[pos - 1];
            })
        }

        this.countries = sort(response.data.countries)

        var cont = response.data.continents
        for(var i=0, j=0; i<cont.length; i++)
          if(cont[i] !== ""){
             this.continents[j] = cont[i]
             j++
          }
        this.continents = sort(this.continents)


      } catch (error) {
        console.error(error)
        alert(error.message)
      } finally {
        // this.$refs.progress.hide()
      }
    },
  },
  async created() {
    this.search.text = this.$route.query.text || ''
    this.search.theme = this.$route.query.theme || ''
    this.search.continent = this.$route.query.continent || ''
    this.search.country = this.$route.query.country || ''
    this.search.numberPage = +this.$route.query.page || 1
    this.search.limit = 4
    this.search.my = this.$route.query.my || false

    this.$nextTick().then(() => this.refreshDisplayProjects())
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/GreenFund/GreenFund.component.js